import { Box, styled } from "@mui/material";

import { Typography } from "components/Typography";

import { WatchlistTabs } from "./components/WatchlistTabs";
import { FlagAccount } from "./components/FlagAccount";

const Wrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const Watchlist = () => {
  return (
    <Box>
      <Wrapper>
        <Typography variant="dashboardHeading">Watchlist</Typography>
        <FlagAccount />
      </Wrapper>
      <Box sx={{ paddingTop: "40px" }}>
        <WatchlistTabs />
      </Box>
    </Box>
  );
};
